import { NotificationStatus } from "@/enums/notifications";

export const JobStatus = {
    PENDING: "PENDING",
    IN_PROGRESS: "IN_PROGRESS",
    COMPLETE: "COMPLETE",
    ABORTED: "ABORTED",
    FAILED: "FAILED"
} as const;

export const JobStatusToNotificationStatus = {
    [JobStatus.ABORTED]: NotificationStatus.Aborted,
    [JobStatus.COMPLETE]: NotificationStatus.Completed,
    [JobStatus.FAILED]: NotificationStatus.Failed,
    [JobStatus.IN_PROGRESS]: NotificationStatus.InProgress,
    [JobStatus.PENDING]: NotificationStatus.Pending
} as const;

export const JobNames = {
    AddMetadataValue: "AddMetadataValue",
    RemoveMetadataValue: "RemoveMetadataValue",

    PublishXmlFeed: "PublishXmlFeed",
    UnpublishXmlFeed: "UnpublishXmlFeed",

    PUBFT_DOWNLOAD_EXCEL: "PUBFT_DOWNLOAD_EXCEL",
    PUBFT_DOWNLOAD_ASSETS: "PUBFT_DOWNLOAD_ASSETS",

    PsdDownloader: "PsdDownloader",

    ScreenshotDownloader: "ScreenshotDownloader",
    VideoDownloader: "VideoDownloader",
    PlainlyBatchRender: "PLAINLY_BATCH_RENDER",

    ADOBE_INDESIGN_DOWNLOAD: "ADOBE_INDESIGN_DOWNLOAD"
} as const;

export const IndesignJobPlatform = {
    INDESIGN_BUNDLE: "indesign_bundle",
    INDESIGN_PDF: "indesign_pdf",
    INDESIGN_JPG: "indesign_jpg",
    INDESIGN_INDD: "indesign"
} as const;
